/* @flow */
import cx from 'classnames';
import React from 'react';

import Button from 'components/Button.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Group from 'entities/Group';
import Message from 'entities/Message';
import MessageActions from 'groups/actions/MessageActions';
import ModalTrigger from 'components/ModalTrigger.jsx';
import MessageItemContent from 'chat/components/MessageItemContent.jsx';
import EditScheduledMessageComposer from 'chat/components/EditScheduledMessageComposer.jsx';

import GroupMessageBase from './GroupMessageBase.jsx';
import GroupMessageHeader from './GroupMessageHeader.jsx';
import GroupMessageHeaderAction from './GroupMessageHeaderAction.jsx';
import GroupMessageInformation from './GroupMessageInformation.jsx';

import './styles/GroupScheduledMessage.scss';

class GroupScheduledMessage extends React.Component {
  props: {
    message: Message,
    group: Group,
    className: string,
  };

  // TODO: Figure out a better way to ignore this click
  // while allowing the event to bubble
  // typecheck: ignore statement
  clickHandler(event: SyntheticEvent) {
    // Prevents the GroupScheduledMessageList from toggling
    // when clicking inside its child (i.e., this)
    event.stopPropagation();
  }

  remove = () => {
    MessageActions.destroyScheduledMessage(this.props.message);
  }

  renderMessage() {
    const { message } = this.props;
    const senderId = message && message.getSender().id;
    return (
      <GroupMessageBase
        message={message}>
        <GroupMessageHeader
          author={message && message.getSender().getName()}
          initials={message && message.getSender().getInitials()}
          color={message && message.getSender().getColor()}
          senderId={senderId}>
          <div>
            <ModalTrigger
              modal={<EditScheduledMessageComposer message={message} onRequestHide={() => MessageActions.clearDraftAnnouncement()} />}>
              <Button level="secondary" size="small">
                Edit
              </Button>
            </ModalTrigger>
            {this.renderRemoveAction()}
          </div>
        </GroupMessageHeader>
        <MessageItemContent message={message} failed={false} />
        <GroupMessageInformation />
      </GroupMessageBase>
    );
  }

  renderRemoveAction() {
    const modal = (
      <ConfirmDialog
        eventScreenName="GroupScheduledMessage"
        title="Are you sure you want to delete this announcement?"
        actionButtonText="Delete"
        cancelButtonText="Cancel"
        onConfirm={this.remove}
      />
    );

    return (
      <ModalTrigger modal={modal} data-test-selector="delete-modal-trigger">
        <GroupMessageHeaderAction color="lava">
          Delete
        </GroupMessageHeaderAction>
      </ModalTrigger>
    );
  }

  render() {
    const { className } = this.props;
    return (
      <div className={cx('GroupScheduledMessage', className)} onClick={this.clickHandler}>
        {this.renderMessage()}
      </div>
    );
  }
}

export default GroupScheduledMessage;



// WEBPACK FOOTER //
// ./src/groups/components/GroupScheduledMessage.jsx